import Main from "../components/main/Main";

const MainPage = () => {
  return <Main />;
};
export default MainPage;
